import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';
import { useAuth } from '../context/AuthContext';

/**
 * Returns whether the user has used their one-time free generation trial.
 * Returns null while the initial snapshot is loading or while the user is not signed in.
 */
export function useTrialGenerationUsed() {
  const { user } = useAuth();
  const [trialGenerationUsed, setTrialGenerationUsed] = useState(null);

  useEffect(() => {
    if (!user) {
      setTrialGenerationUsed(null);
      return undefined;
    }
    const ref = doc(db, 'users', user.uid);
    const unsub = onSnapshot(ref, (snap) => {
      setTrialGenerationUsed(snap.exists() ? snap.data()?.trialGenerationUsed === true : false);
    });
    return unsub;
  }, [user]);

  return trialGenerationUsed;
}
